import { doc, collection, setDoc, addDoc, getDocs, deleteDoc, getDoc, query, where } from "firebase/firestore";
import {db} from "./FirebaseConfig"

const storeObject = async(id, objectType, object) => {
  let docRef;
  if(id)
    docRef = doc(db, objectType, id);
  else {
    docRef = await addDoc(collection(db, objectType), object);
    object = {...object, id: docRef.id}
  }
  await setDoc(docRef, object);
  return object;
}

const deleteObject = async (id, objectType) => {
  const docRef = doc(db, objectType, id);
  await deleteDoc(docRef);
}

export const storeUserAccount = async(id, account) => {return await storeObject(id, 'Accounts', account);}
export const storeUserCategory = async(id, category) => {return await storeObject(id, 'Categories', category);}
export const storeUserFriend = async(id, friend) => {return await storeObject(id, 'Friends', friend);}
export const storeUserTrip = async(id, trip) => {return await storeObject(id, 'Trips', trip);}
export const storeUserTag = async(id, tag) => {return await storeObject(id, 'Tags', tag);}
export const storeUserEvent = async(id, event) => {return await storeObject(id, 'Events', event);}

export const deleteUserCategory = async(id) => {deleteObject(id, 'Categories');}
export const deleteUserFriend = async(id) => {deleteObject(id, 'Friends');}
export const deleteUserTrip = async(id) => {deleteObject(id, 'Trips');}
export const deleteUserTag = async(id) => {deleteObject(id, 'Tags');}
export const deleteUserEvent = async(id) => {deleteObject(id, 'Events');}

export const categoryIsInEvents = async(category) => {return false;}
export const friendIsInEvents = async(friend) => {return false;}
export const tripIsInEvents = async(trip) => {return false;}
export const tagIsInEvents = async(tag) => {return false;}

export const getUserAccount = async (username) => {
  return await getDocs(collection(db, 'Accounts')).then((querySnapshot)=>{    
    for(let accountDoc of querySnapshot.docs){
      const user = accountDoc.data();
      if(user.username.toLowerCase() == username.toLowerCase())
        return user;
    }
    return null;            
  });
}

export const getUserData = async (userId) => {
  const queries = [
    getDocs(query(collection(db, 'Friends'), where("userId", "==", userId))),
    getDocs(query(collection(db, 'Categories'), where("userId", "==", userId))),
    getDocs(query(collection(db, 'Trips'), where("userId", "==", userId))),
    getDocs(query(collection(db, 'Tags'), where("userId", "==", userId))),
    getDocs(query(collection(db, 'Events'), where("userId", "==", userId)))
  ]
  return await Promise.all(queries).then((querySnapshots)=>{
    const userData = {
      friends: Object.assign({}, ...querySnapshots[0].docs.map((x) => ({[x.id]: x.data()}))),
      categories: Object.assign({}, ...querySnapshots[1].docs.map((x) => ({[x.id]: x.data()}))),
      trips: Object.assign({}, ...querySnapshots[2].docs.map((x) => ({[x.id]: x.data()}))),
      tags: Object.assign({}, ...querySnapshots[3].docs.map((x) => ({[x.id]: x.data()}))),
      events: Object.assign({}, ...querySnapshots[4].docs.map((x) => ({[x.id]: x.data()}))),
    }
    return userData;
  });
}

export const getLoggedInUserAccount = async (user) => {
  const accountDocRef = doc(db, 'Accounts', user.uid);
  const acountDoc = await getDoc(accountDocRef);
  if(acountDoc.exists())
    return acountDoc.data();
  else{
    const newUserAccount = {
      id: user.uid,
      username: await getUsername(user),
      displayName: user.displayName,
    };
    setDoc(accountDocRef, newUserAccount);
    return newUserAccount;
  }
}

const getUsername = async (user) => {
  let username = user.displayName.replaceAll(' ', '');
  let num = 1;
  while(await getUserAccount(username)){
    username += num;
    num += 1;
  }
  return username;
}
